import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

import { Breadcrumbs } from 'dibs-elements/exports/Breadcrumbs';

// helpers
import get from 'lodash.get';
import { trackBreadcrumbClick } from './breadcrumbTracking';

function PdpRespBreadcrumbsComponent(props) {
    const breadcrumbs = get(props, 'item.breadcrumbs') || [];

    const handleBreadcrumbClick = e => {
        const { key } = breadcrumbs.find(({ path }) => {
            return path === e.target.pathname;
        });
        trackBreadcrumbClick(key);
    };

    return (
        <Breadcrumbs breadcrumbs={breadcrumbs} onClick={handleBreadcrumbClick} isLastItemActive />
    );
}

PdpRespBreadcrumbsComponent.propTypes = {
    item: PropTypes.object,
};

export const PdpRespBreadcrumbs = createFragmentContainer(PdpRespBreadcrumbsComponent, {
    item: graphql`
        fragment PdpRespBreadcrumbs_item on Item {
            breadcrumbs {
                key
                path
                displayName
            }
        }
    `,
});
